import React, { Component, Fragment } from 'react'
import moment from 'moment'

import StepNext from '../StepNext'
import StepQuizz from '../StepQuizz'
import StepResults from '../StepResults'
import StepShare from '../StepShare'
import StepTripSlider from '../StepTripSlider'
import SliderArrow from '../../Global/SliderArrow'

class TripFooter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      questions: [],
    }
  }
  componentDidMount() {
    const { trip, trip: { acf: { steps }}} = this.props
    const expirationDuration = 86400 // 1 day
    const totalQuestions = steps.filter(step => !step.activation_question).length

    if (steps.length !== totalQuestions) {
      if (window.sessionStorage.getItem('quizz')) {
        // In case sessionStorage "quizz" exists, check if all questions are stocked
        const questions = JSON.parse(window.sessionStorage.getItem('quizz'))

        // If the question in not stocked in sessionStorage, add it
        if (questions.filter(question => question.id === trip.id).length === 0) {
          questions.push({
            id: trip.id,
            expirationDate: moment().unix() + expirationDuration,
            questions: steps
              .map((step, index) => (
                {
                  step: index + 1,
                  enableQuestion: step.activation_question,
                  isAnswered: false,
                  isRight: null,
                }
              ))
          })
        } else {
          // If expiration date has expired
          for (let i = 0; i < questions.length; i++) {
            const question = questions[i]

            if (question.id === trip.id && moment().unix() > question.expirationDate) {
              questions.splice(i, 1)
              i--

              questions.push({
                id: trip.id,
                expirationDate: moment().unix() + expirationDuration,
                questions: steps
                  .map((step, index) => (
                    {
                      step: index + 1,
                      enableQuestion: step.activation_question,
                      isAnswered: false,
                      isRight: null,
                    }
                  ))
              })
            }
          }
        }

        window.sessionStorage.setItem('quizz', JSON.stringify(questions))
      } else {
        // If there is no sessionStorage "quizz", create it
        const questions = [
          {
            id: trip.id,
            expirationDate: moment().unix() + expirationDuration,
            questions: steps
              .map((step, index) => (
                {
                  step: index + 1,
                  enableQuestion: step.activation_question,
                  isAnswered: false,
                  isRight: null,
                }
              ))
          }
        ]

        window.sessionStorage.setItem('quizz', JSON.stringify(questions))
      }

      this.setState({
        questions: JSON.parse(window.sessionStorage.getItem('quizz')),
      })
    }
  }
  render() {
    const {
      currentStep,
      totalSteps,
      trips,
      trip,
      trip: {
        acf: {
          steps,
          message_correct_answer,
          message_incorrect_answer
        },
        slug
      },
    } = this.props
    const { questions } = this.state
    const step = trip.acf.steps[currentStep - 1]
    const totalQuestions = steps.filter(step => step.activation_question).length
    const tripHasQuizz = steps.length !== steps.filter(step => !step.activation_question).length
    const sliderSettings = {
      dots: true,
      infinite: true,
      prevArrow: <SliderArrow to="prev" />,
      nextArrow: <SliderArrow to="next" />,
      slidesToShow: 1,
      slidesToScroll: 1,
    }

    return (
      <div className="trip__footer">
        {
          (questions.length > 0 && step.activation_question) && (
            <StepQuizz
              currentStep={currentStep}
              questions={questions.filter(question => question.id === trip.id)[0]}
              question={step.bloc_question}
              labelRight={message_correct_answer}
              labelWrong={message_incorrect_answer}
            />
          )
        }
        {currentStep !== totalSteps
            /* Not the last Step */
          ? <StepNext currentStep={currentStep} slug={slug} />
          : (
            /* Last Step */
            <Fragment>
              {/* If there is no question in this trip, display StepShare */}
              {!tripHasQuizz && (
                <Fragment>
                  <StepShare trip={trip} />
                </Fragment>
              )}

              {/* If all enabled questions have isAnswered set to true, display StepResults */}
              {tripHasQuizz && questions.length > 0 && questions
                .filter(question => question.id === trip.id)[0]
                .questions
                .filter(question => question.enableQuestion)
                .every(question => question.isAnswered) && (
                  <StepResults
                    questions={questions.filter(question => question.id === trip.id)[0]}
                    totalQuestions={totalQuestions}
                    trip={trip}
                  />
                )}

                {!steps[currentStep - 1].hide_bloc_available_trips && <StepTripSlider trips={trips} sliderSettings={sliderSettings} />}
            </Fragment>
          )
        }
      </div>
    )
  }
}

export default TripFooter


// WEBPACK FOOTER //
// ./src/components/Step/StepFooter/StepFooter.js